import { RouterProvider } from 'react-router'
import Header from './frontend/components/Header'
import App from './frontend/App'
import ClientRouter from './frontend/Router/clientRouter'

function ClientApp({ hydrationData }: { hydrationData: Record<string, any> }) {
    return <App>
        <ClientRouter hydrationData={hydrationData} />
    </App>
}

export default ClientApp